module.exports = __webpack_public_path__ + "static/media/42.ba837843.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/res/thumbnails/42.jpg
// module id = 988
// module chunks = 0